import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../navigation/sellerNavigation";
import { getData } from "../../fetchRoutes/getData";
import BarChart from "./charts/barChart";
import WordCloudChart from "./charts/wordCloudChart";
import PieChart from "./charts/pieChart";
import ScatterChart from "./charts/scatterChart";
import SellerMobileSidebar from "../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../context/deviceContext";

export default function BuyerDashboardContainer() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const buyerAnalyticsURL = process.env.REACT_APP_GET_ANALYTICS;

  const { isMobile } = useContext(DeviceContext);

  const [currentPage, setCurrentPage] = useState(1);
  const chartsPerPage = isMobile ? 2: 4;

  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      try {
        const response = await getData(buyerAnalyticsURL);
        if (response.status === "success") {
          setAnalytics(response.data);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [buyerAnalyticsURL]);

  // Chart components for pagination
  const chartComponents = analytics
    ? [
        <BarChart data={analytics.bidPerProperty} key="bar" />,
        <WordCloudChart data={analytics.wordCloud} key="word" />,
        <PieChart data={analytics.bidStats} key="pie" />,
        <ScatterChart data={analytics.bidsOverTime} key="scatter" />,
      ]
    : [];

  const totalPages = Math.ceil(chartComponents.length / chartsPerPage);
  const indexOfLastChart = currentPage * chartsPerPage;
  const indexOfFirstChart = indexOfLastChart - chartsPerPage;
  const currentCharts = chartComponents.slice(indexOfFirstChart, indexOfLastChart);

  return (
    <div className="sellerDashboard">
      {isMobile ? <SellerMobileSidebar /> : <SellerSidebar />}
      <div className="container moreProperties">
        <h1 className="containerTitle">MY DASHBOARD</h1>

        {loading && (
          <div className="loaderContainer">
            <div className="loader"></div>
            <p className="loadingText">Loading data...</p>
          </div>
        )}

        {error && <p style={{ color: "red" }}>{error}</p>}

        {analytics && (
          <>
            <div className="chartGrid">{currentCharts}</div>

            {totalPages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className={`btnPagination ${currentPage === 1 ? "disabled" : ""}`}
                >
                  Previous
                </button>

                <span className="pageInfo">Page {currentPage} of {totalPages}</span>

                <button
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className={`btnPagination ${currentPage === totalPages ? "disabled" : ""}`}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
